module.exports = __webpack_public_path__ + "img/fsa.95e9e729.jpg";